import { useQuery } from "@apollo/client/react";
import { Grid } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import DataGridGenerico from "../../../../../components/dataGrid/DataGridGenerico";
import { generateColumnsDefaultConfiguration } from "../../../../../components/dataGrid/columnHelpers";
import toast from "react-hot-toast";
import { getTabIndicacionSolicitudEstadoChip } from "../../hooks/TabIndicacion/getTabIndicacionSolicitudEstadoChip";
import { GET_INDICACION_APROBACION_INSUMO_BYID } from "../../../../../data/graphQL/queries/GestionAsistencial/getIndicacionAprobacionInsumoById";
import { GET_INDICACION_APROBACION_RESPUESTAS } from "../../../../../data/graphQL/queries/GestionAsistencial/getIndicacionAprobacionRespuestas";
import moment from "moment";

export function TabIndicationViewSolicitudDialog({
  open,
  handleCloseDialog,
  solicitudSelected
}) {

  const { idIndicacion, fechaDesde, fechaHasta } = solicitudSelected;
  const [rows, setRows] = useState([]);
  const [respuestas, setRespuestas] = useState(null);

  const initialColumns = [
  {
    field: 'idInsumoN',
    headerName: 'ID Producto',
    align: 'center',
    flex: 0.1
  },
  {
    field: 'insumo',
    headerName: 'Producto',
    flex: 0.4
  },
  {
    field: 'cantidad',
    headerName: 'Cantidad',
    flex: 0.1
  },
  {
    field: 'unidad',
    headerName: 'Unidad',
    flex: 0.1
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), [rows]);

  const { data: dataIndicacionAprobacion, loading } = useQuery(GET_INDICACION_APROBACION_INSUMO_BYID, {
    fetchPolicy: "no-cache",
    variables: { idIndicacionAprobacion: solicitudSelected?.idIndicacionAprobacion }
  });

  useEffect(() => {
    if (!dataIndicacionAprobacion) return;
    if (dataIndicacionAprobacion?.indicacionAprobacionInsumoById.success) {
      setRows(dataIndicacionAprobacion?.indicacionAprobacionInsumoById.valorEsperado);
    } else {
      setRows([]);
      toast.error("Error al consultar los productos de la solicitud.");
    }
  }, [dataIndicacionAprobacion]);

  const { data: dataResp, loading: loadingResp } = useQuery(GET_INDICACION_APROBACION_RESPUESTAS, {
    fetchPolicy: "no-cache",
    variables: { idIndicacionAprobacion: solicitudSelected?.idIndicacionAprobacion }
  });

  useEffect(() => {
    if (!dataResp) return;
    if (dataResp?.indicacionAprobacionRespuestas.success) {
      setRespuestas(dataResp?.indicacionAprobacionRespuestas.valorEsperado);
    } else {
      setRespuestas(null);
      toast.error("Error al consultar las respuestas de la solicitud.");
    }
  }, [dataResp]);

  return (
    <CustomDialog
      title={"Ver solicitud"}
      open={open}
      fullWidth
      maxWidth="md"
      onCancel={handleCloseDialog}
      cancelText="Cancelar">
      
      <Grid
        container
        spacing={2}
        sx={{ marginBottom: '25px' }}>
        
        <Grid size={{ xs: 12, md: 2 }}>
          <div className='contrato-card-label'><strong>Número</strong></div>
          <div>{solicitudSelected.idIndicacionAprobacion}</div>
        </Grid>
        <Grid size={{ xs: 12, md: 2 }}>
          <div className='contrato-card-label'><strong>Contrato</strong></div>
          <div>{solicitudSelected.idEvaluacion}</div>
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          <div className='contrato-card-label'><strong>Solicitante</strong></div>
          <div>{solicitudSelected.solicitante}</div>
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          <div className='contrato-card-label'><strong>Período</strong></div>
          <div>{solicitudSelected.periodo}</div>
        </Grid>
        <Grid size={{ xs: 12, md: 2 }}>
          <div className='contrato-card-label'><strong>Fecha alta</strong></div>
          <div>{solicitudSelected.fechaAlta}</div>
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <div className='contrato-card-label'><strong>Observación solicitante</strong></div>
          <div>{solicitudSelected.observacionSolicitante != '' ? solicitudSelected.observacionSolicitante : '-'}</div>
        </Grid>
      </Grid>

      <div className='contrato-card-label'><strong>Detalle de productos</strong></div>
      <br />
      <DataGridGenerico
        columns={columns}
        rows={rows}
        toolbar={false}
        loading={loading}
        fullWidth
        hideFooter />
      

      <br /><br />
      <div className='contrato-card-label' style={{ fontSize: '11pt' }}><strong>Respuestas</strong></div>
      <br />
      <Grid
        container
        spacing={2}
        sx={{ marginBottom: '25px' }}>
        
        <Grid size={{ xs: 12, md: 4 }}>
          <div className='contrato-card-label'><strong>Respuesta Médica</strong></div>
          <div>{getTabIndicacionSolicitudEstadoChip(respuestas?.idEstadoMedico)}</div>
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          <div className='contrato-card-label'><strong>Médico</strong></div>
          <div>{respuestas?.usuarioMedico != '' ? respuestas?.usuarioMedico : '-'}</div>
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          <div className='contrato-card-label'><strong>Fecha</strong></div>
          <div>{respuestas?.idEstadoMedico > 1 ? moment(respuestas?.fechaMedico).format('DD/MM/YYYY HH:mm:ss') : '-'}</div>
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <div className='contrato-card-label'><strong>Observación médica</strong></div>
          <div>{respuestas?.observacionMedico ? respuestas?.observacionMedico : '-'}</div>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={2}
        sx={{ marginBottom: '25px' }}>
        
        <Grid size={{ xs: 12, md: 4 }}>
          <div className='contrato-card-label'><strong>Respuesta Comercial</strong></div>
          <div>{respuestas?.idEstadoComercial != '' ? getTabIndicacionSolicitudEstadoChip(respuestas?.idEstadoComercial) : '-'}</div>
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          <div className='contrato-card-label'><strong>Comercial</strong></div>
          <div>{respuestas?.usuarioComercial != '' ? respuestas?.usuarioComercial : '-'}</div>
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          <div className='contrato-card-label'><strong>Fecha</strong></div>
          <div>{respuestas?.idEstadoComercial > 1 ? moment(respuestas?.fechaComercial).format('DD/MM/YYYY HH:mm:ss') : '-'}</div>
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <div className='contrato-card-label'><strong>Observación comercial</strong></div>
          <div>{respuestas?.observacionComercial ? respuestas?.observacionComercial : '-'}</div>
        </Grid>
      </Grid>

    </CustomDialog>);

}